<template>
  <div class="col-sm-12 nopads">
    <div class="col-sm-12 editor-form">
      <h3 class="editor-header">{{ costCenterUpdate.id > 0 ? $t('costcenters.edit') : $t('costcenters.add')}}</h3>
        <div class="row">
            <div class="col-sm-6">
                <span class="span-title">
                  {{ $t('common.number') }}
                </span>
                <input
                    id="name"
                    v-model="costCenterUpdate.number"
                    type="text"
                    required
                    class="form-control form-control-sm"
                />
            </div>
            <div class="col-sm-6">
                <span class="span-title">
                  {{ $t('costcenters.name') }}
                </span>
                <input
                    id="name"
                    v-model="costCenterUpdate.name"
                    type="text"
                    required
                    class="form-control form-control-sm"
                />
            </div>
        </div>
        <div class="col-sm-12 d-flex justify-content-end my-2">
          <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
              {{ $t('common.cancel') }}
          </button>
          <button class="btn btn-success form-button" :disabled="loading || !costCenterUpdate.name || !costCenterUpdate.number" @click.stop="submitCostCenter">
              {{ $t('common.save') }}
          </button>
        </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import {restApi} from '../mixins/RestApiMixin'
import {inject} from "vue";

export default {
    name: 'CostCenterEditor',
    mixins: [workManagementHelper, restApi],
    props: {
        costCenter: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            costCenterUpdate: this.jsonToItem(this.costCenter)
        }
    },

    methods: {
        setDefaultValues: function (costCenter) {
            if (costCenter.name === '') {
                this.showAlert(this.$t('inspectable_editor.invalid_name'))
                return undefined
            }
            return costCenter
        },

        submitCostCenter: function () {
            var json = this.setDefaultValues(this.costCenterUpdate)
            if (json !== undefined) {
                this.loading = true
                if (this.costCenter.id < 1) {
                    this.restAdd(this.costCenterUrl, json, this.success, this.fail)
                } else {
                    this.restUpdate(this.costCenterUrl, json, this.success, this.fail)
                }
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }

    }
}
</script>
